import styled, { css } from "styled-components";
function getSimpleSearchHoverDeclarations({ theme, selected, focused, disabled, }) {
    if (disabled) {
        return "";
    }
    if (!selected && !focused) {
        return `
        border-bottom: 1px solid ${theme.colors.grey14};
        background-color: rgba(${theme.colors.transparentBlack}, 0.04);
    `;
    }
    return `border-bottom: 1px solid ${theme.colors.grey14};`;
}
const simpleSearchStyles = ({ theme, selected, focused, disabled, }) => css `
  input {
    padding: 0rem calc(3rem - 3px) 0rem 1rem;
    height: 3rem;
    border-bottom: 1px solid
      ${selected ? theme.colors.black : theme.colors.grey10};
    font-size: ${theme.fontTokens.font09[0]};
    font-weight: ${theme.fontWeights.normal};
    line-height: ${theme.fontTokens.font09[1]};
    &::placeholder {
      font-size: ${theme.fontTokens.font09[0]};
      font-weight: ${theme.fontWeights.normal};
      color: ${theme.colors.grey12};
    }

    + span,
    + button,
    + button > span {
      height: 3rem;
      width: 3rem;
      min-width: 3rem;
    }

    @media (hover: hover) {
      &:hover {
        ${getSimpleSearchHoverDeclarations({
    theme,
    selected,
    focused,
    disabled,
})}
      }
    }

    &:active {
      ${!disabled
    ? `
      border-bottom: 1px solid ${theme.colors.black};
      background-color: rgba(${theme.colors.transparentBlack}, 0.06);
    `
    : ""}
    }

    + span svg {
      height: 1.25rem;
      width: 1.25rem;
    }

    &.main-search + span svg {
      height: 1.5rem;
      width: 1.5rem;
    }

    &:disabled {
      background-color: transparent;
      border: 1px solid rgba(${theme.colors.transparentBlack}, 0);
      border-bottom: 1px solid rgba(${theme.colors.transparentBlack}, 0.2);
      color: rgba(${theme.colors.transparentBlack}, 0.2);
      caret-color: rgba(${theme.colors.transparentBlack}, 0.2);
      &::placeholder {
        color: rgba(${theme.colors.transparentBlack}, 0.2);
      }
      + span svg {
        fill: rgba(${theme.colors.transparentBlack}, 0.2);
      }
    }
  }
`;
function getOutlinedSearchHoverDeclarations({ theme, selected, focused, disabled, }) {
    if (disabled) {
        return "";
    }
    if (!selected && !focused) {
        return `
      border: 1px solid ${theme.colors.grey14};
      background-color: ${theme.colors.offWhite};
    `;
    }
    return `border: 1px solid ${theme.colors.grey14};`;
}
const outlinedSearchStyles = ({ theme, selected, focused, disabled, }) => css `
  input {
    padding: 0rem calc(2.5rem - 3px) 0rem 0.5rem;
    height: 2.5rem;
    @media ${theme.device.touch} {
      height: 2.75rem;
    }
    background-color: ${theme.colors.white};

    &::placeholder {
      font-size: ${theme.fontTokens.font12[0]};
      font-weight: ${theme.fontWeights.regular};
      color: rgba(${theme.colors.transparentBlack}, 0.36);
    }
    border: 1px solid ${selected ? theme.colors.black : theme.colors.grey10};
    font-size: ${theme.fontTokens.font12[0]};
    line-height: ${theme.fontTokens.font12[1]};

    &:disabled {
      background-color: rgba(${theme.colors.transparentBlack}, 0.04);
      border: 1px solid rgba(${theme.colors.transparentBlack}, 0);
      &::placeholder {
        font-size: ${theme.fontTokens.font12[0]};
        color: rgba(${theme.colors.transparentBlack}, 0.26);
      }

      + span svg {
        fill: rgba(${theme.colors.transparentBlack}, 0.26);
      }
    }

    > span {
      display: flex;
      align-items: center;
    }
    + span svg {
      height: 1.25rem;
      width: 1.25rem;
    }

    @media (hover: hover) {
      &:hover {
        ${getOutlinedSearchHoverDeclarations({
    theme,
    selected,
    focused,
    disabled,
})}
      }
    }

    &:active {
      ${!disabled
    ? `
      border: 1px solid ${theme.colors.black};
      background-color: ${theme.colors.grey05};
    `
    : ""}
    }
  }
`;
export const StyledWrapper = styled.div `
  position: relative;
  width: 100%;

  input {
    outline: none;
    font-family: ${({ theme }) => theme.fontTokens.defaultFont};
    z-index: 9;
    width: 100%;
    box-sizing: border-box;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 0px;
    -webkit-appearance: none;
    appearance: none;
    + span svg {
      fill: ${({ selected, theme }) => selected ? theme.colors.black : theme.colors.grey12};
    }

    &:focus {
      ${({ focused, theme }) => focused ? `outline: 2px solid ${theme.colors.primaryLight};` : ""}
    }

    + span {
      pointer-events: none;
      background-color: transparent;
      position: absolute;
      border: 1px solid transparent;
      box-sizing: border-box;
      right: 0;
      top: 0;
      z-index: 9;
    }
    + button {
      z-index: 9;
      position: absolute;
      right: 0;
      bottom: 0;
      > span {
        display: flex;
        align-items: center;
      }
      > span svg {
        height: 1.25rem;
        width: 1.25rem;
      }
    }
  }

  &:active {
    ${({ theme }) => theme.global.disableTapHighlight}
    // safari
    @supports (-webkit-hyphens:none) {
      user-select: auto;
      -webkit-user-select: auto;
    }

    input {
      outline: none;
      + span svg {
        fill: ${({ disabled, theme }) => (!disabled ? theme.colors.black : "")};
      }
    }
  }

  form {
    div {
      position: absolute;
      width: 100%;
    }
  }

  ${(props) => props.outlined ? outlinedSearchStyles(props) : simpleSearchStyles(props)}
`;
export const SearchWrapper = styled.div `
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  > button {
    margin-top: 1rem;
    flex-grow: 1;
    width: 100%;
  }

  @media ${({ theme }) => theme.device.medium} {
    flex-direction: row;
    > button {
      margin-left: 1rem;
      margin-top: 0rem;
      width: auto;
    }
  }
`;
export const FlyoutWrapper = styled.div `
  margin-top: 0.1rem;
`;
